import {
  GetAllJobVacancies,
  GetAllJobVacanciesList,
  GetAllJobVacanciesProp,
  GetAllTechnology,
  JobVacancy,
  JobVacancyAudit,
  VendorResponse,
} from '../../../../types/Recruitment/JobOpenings/jobOpeningsTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import { AllowedHttpMethods, jobOpeningsApiConfig } from '../../apiList'

const getAllJobVacancies = async (
  props: GetAllJobVacanciesProp,
): Promise<GetAllJobVacancies> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: jobOpeningsApiConfig.getAllJobVacancies,
    method: AllowedHttpMethods.get,
    params: {
      searchJobTitle: props.searchJobTitle,
      endIndex: props.endIndex,
      startIndex: props.startIndex,
      status: props.status,
      vendorEmployeeId: props.vendorEmployeeId,
      isVendor: props.isVendor,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getAllTechnology = async (): Promise<GetAllTechnology[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: jobOpeningsApiConfig.getAllTechnology,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const addJobVacancy = async (data: JobVacancy): Promise<JobVacancy> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: jobOpeningsApiConfig.addJobVacancy,
    method: AllowedHttpMethods.post,
    data,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const deleteJobVacancy = async (jobvacancyId: number): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: jobOpeningsApiConfig.deleteJobVacancy,
    method: AllowedHttpMethods.post,
    params: {
      jobvacancyId,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getJobOpeningById = async (
  jobVacancyId: number,
): Promise<GetAllJobVacanciesList> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: jobOpeningsApiConfig.getJobOpeningById,
    method: AllowedHttpMethods.get,
    params: {
      jobVacancyId,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getJobVacancyAudit = async (
  jobVacancyId: number,
): Promise<JobVacancyAudit> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: jobOpeningsApiConfig.getJobVacancyAudit,
    method: AllowedHttpMethods.get,
    params: {
      jobVacancyId,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const updateJobVacancy = async (
  data: GetAllJobVacanciesList,
): Promise<GetAllJobVacanciesList> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: jobOpeningsApiConfig.updateJobVacancy,
    method: AllowedHttpMethods.post,
    data,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const isCandidateMappedWithJob = async (jobCode: string): Promise<boolean> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: jobOpeningsApiConfig.isCandidateMappedWithJob,
    method: AllowedHttpMethods.get,
    params: {
      jobCode,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getActiveVendorsList = async (): Promise<VendorResponse[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: jobOpeningsApiConfig.getActiveVendorsList,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const editVendorJobDetails = async (
  id: number,
): Promise<GetAllJobVacancies> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: jobOpeningsApiConfig.editVendorJobDetails,
    method: AllowedHttpMethods.get,
    params: {
      id,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const jobOpeningsApi = {
  getAllJobVacancies,
  getAllTechnology,
  addJobVacancy,
  deleteJobVacancy,
  getJobOpeningById,
  getJobVacancyAudit,
  updateJobVacancy,
  isCandidateMappedWithJob,
  getActiveVendorsList,
  editVendorJobDetails,
}

export default jobOpeningsApi
